import { Component, OnInit, Injector, ElementRef, ViewChild, OnDestroy, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Repository } from '../../services/repository'
declare var $: any;

import { MenuService } from '../../core/menu/menu.service';
import { SettingsService } from '../../core/settings/settings.service';
import { DaoTaos_HocVien } from 'src/app/routes/menu';
import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy, AfterViewChecked {

  returnUrl: string;
  menuItems: Array<any>;
  router: Router;
  sbclickEvent = 'click.sidebar-toggle';
  $doc: any = null;
  //============Eduno ai
  // Add ViewChild reference to the chat container
  @ViewChild('chatContainer') private chatContainer: ElementRef;
  // Add flag to track if auto-scroll should happen
  private shouldScrollToBottom = true;
  messages: any[] = [];
  newMessage: string = '';
  isTyping: boolean = false;
  isChatOpen: boolean = true;
  doituongSelect: any = {
    DonViId: null, UserName: null, ChiTiets: null
  };
  private configLoaded = false; // Thêm flag để theo dõi trạng thái load config
  //=======================================
  currentUser: any;

  constructor(
    public menu: MenuService,
    private route: ActivatedRoute,
    public settings: SettingsService,
    public injector: Injector,
    public repo: Repository,
    private chatService: ChatService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.menuItems = menu.getMenu().slice(0, 9);
    this.addBotMessage('Xin chào! Tôi là trợ lý Eduno, bạn cần tôi giúp gì không?');

    this.doituongSelect.DonViId = this.currentUser.id_don_vi;
    this.doituongSelect.UserName = this.currentUser.user_name;

    // Load configuration
    this.loadChatConfiguration();

    // Subscribe to chat service - di chuyển vào ngOnInit để đảm bảo an toàn
  }

  ngOnInit() {
    this.router = this.injector.get(Router);
    this.loadChatHistory();

    // Subscribe to chat service sau khi component đã khởi tạo
    this.chatService.chatOpen$.subscribe(isOpen => {
      this.isChatOpen = isOpen;
      this.updateChatConfiguration();
    });

    this.router.events.subscribe((val) => {
      this.removeFloatingNav();
      window.scrollTo(0, 0);
      this.settings.setLayoutSetting('asideToggled', false);
    });

    this.anyClickClose();
  }

  private loadChatConfiguration() {
    this.repo.postRequest("api/cauhinhhienthi/getbyds/", {
      DonViId: this.currentUser.id_don_vi,
      PhanHeId: DaoTaos_HocVien.id,
      UserName: this.currentUser.user_name,
      ChiTiets: [{ Ten: "isChatOpen" }]
    }).subscribe(response => {
      if (response && response.length > 0) {
        this.isChatOpen = response[0].HienThi;
        this.doituongSelect.ChiTiets = response;
        this.configLoaded = true;

        // Đồng bộ trạng thái với chat service sau khi load config
        this.chatService.setChatState(this.isChatOpen);
      }
    }, error => {
      console.error('Lỗi khi tải cấu hình chat:', error);
      this.configLoaded = true; // Đặt flag thành true ngay cả khi có lỗi
    });
  }

  private updateChatConfiguration() {
    // Chỉ cập nhật configuration khi đã load được config và ChiTiets tồn tại
    if (this.configLoaded && this.doituongSelect.ChiTiets && this.doituongSelect.ChiTiets.length > 0) {
      this.doituongSelect.ChiTiets[0].HienThi = this.isChatOpen;
      this.repo.postRequest("api/cauhinhhienthi/addorupdate/", this.doituongSelect)
        .subscribe(
          response => {
            console.log('Cập nhật cấu hình chat thành công');
          },
          error => {
            console.error('Lỗi khi cập nhật cấu hình chat:', error);
          }
        );
    }
  }

  logout() {
    this.repo.logout();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    location.href = '/Home/Logout';
  }

  clearChatHistory() {
    if (confirm('Bạn có chắc chắn muốn xóa tất cả tin nhắn chat?')) {
      this.messages = [];

      if (this.currentUser) {
        this.repo.postRequest('/api/chatai/clearhistory', { username: this.currentUser.user_name })
          .subscribe(
            (response: any) => {
              this.addBotMessage('Lịch sử chat đã được xóa. Tôi là trợ lý Eduno, bạn cần tôi giúp gì không?');
            },
            (error) => {
              console.error('Lỗi khi xóa lịch sử chat:', error);
              this.addBotMessage('Có lỗi xảy ra khi xóa lịch sử chat. Vui lòng thử lại sau.');
            }
          );
      } else {
        this.addBotMessage('Lịch sử chat đã được xóa. Tôi là trợ lý Eduno, bạn cần tôi giúp gì không?');
      }
    }
  }

  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  loadChatHistory() {
    if (!this.currentUser) {
      return;
    }

    this.repo.getRequest(`/api/chatai/history?username=${this.currentUser.user_name}`)
      .subscribe(
        (response: any) => {
          if (response && response.success && response.data) {
            this.messages = [];

            response.data.forEach(msg => {
              if (msg.IsFromUser) {
                this.addUserMessage(msg.Content, new Date(msg.Timestamp));
              } else {
                this.addBotMessage(msg.Content, new Date(msg.Timestamp));
              }
            });

            setTimeout(() => this.scrollToBottom(), 100);
          }
        },
        (error) => {
          console.error('Lỗi khi tải lịch sử chat:', error);
        }
      );
  }

  scrollToBottom(): void {
    try {
      if (this.shouldScrollToBottom && this.chatContainer) {
        this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
      }
    } catch (err) { }
  }

  anyClickClose() {
    this.$doc = $(document).on(this.sbclickEvent, (e) => {
      if (!$(e.target).parents('.aside-container').length) {
        this.settings.setLayoutSetting('asideToggled', false);
      }
    });
  }

  ngOnDestroy() {
    if (this.$doc)
      this.$doc.off(this.sbclickEvent);
  }

  toggleSubmenuClick(event) {
    event.preventDefault();

    if (!this.isSidebarCollapsed() && !this.isSidebarCollapsedText() && !this.isEnabledHover()) {
      let ul = $(event.currentTarget.nextElementSibling);
      let parentNav = ul.parents('.sidebar-subnav');

      $('.sidebar-subnav').each((idx, el) => {
        let $el = $(el);
        if (el !== parentNav[0] && el !== ul[0]) {
          this.closeMenu($el);
        }
      });

      if (!ul.length) {
        return;
      }

      ul.find('.sidebar-subnav').each((idx, el) => {
        this.closeMenu($(el));
      });

      const ulHeight = ul.css('height')
      if (ulHeight === 'auto' || parseInt(ulHeight, 10)) {
        this.closeMenu(ul);
      } else {
        ul.on('transitionend', () => {
          ul.css('height', 'auto').off('transitionend');
        }).css('height', ul[0].scrollHeight);
        ul.addClass('opening');
      }
    }
  }

  closeMenu(elem) {
    elem.css('height', elem[0].scrollHeight);
    elem.css('height', 0);
    elem.removeClass('opening');
  }

  toggleSubmenuHover(event) {
    let self = this;
    if (this.isSidebarCollapsed() || this.isSidebarCollapsedText() || this.isEnabledHover()) {
      event.preventDefault();
      this.removeFloatingNav();

      let ul = $(event.currentTarget.nextElementSibling);
      let anchor = $(event.currentTarget);

      if (!ul.length) {
        return;
      }

      let $aside = $('.aside-container');
      let $asideInner = $aside.children('.aside-inner');
      let $sidebar = $asideInner.children('.sidebar');
      let mar = parseInt($asideInner.css('padding-top'), 0) + parseInt($aside.css('padding-top'), 0);
      let itemTop = ((anchor.parent().position().top) + mar) - $sidebar.scrollTop();

      let floatingNav = ul.clone().appendTo($aside);
      let vwHeight = document.body.clientHeight;

      floatingNav.addClass('nav-floating')

      var safeOffsetValue = (40 * 5)
      var navHeight = floatingNav.outerHeight(true) + 2;
      var safeOffset = navHeight < safeOffsetValue ? navHeight : safeOffsetValue;
      var displacement = 25;
      var menuTop = (vwHeight - itemTop > safeOffset) ? itemTop : (vwHeight - safeOffset - displacement);

      floatingNav
        .removeClass('opening')
        .css({
          position: this.settings.getLayoutSetting('isFixed') ? 'fixed' : 'absolute',
          top: menuTop,
          bottom: (floatingNav.outerHeight(true) + menuTop > vwHeight) ? (displacement + 'px') : 'auto'
        });

      floatingNav
        .on('mouseleave', () => { floatingNav.remove(); })
        .find('a').on('click', function (e) {
          e.preventDefault();
          let routeTo = $(this).attr('route');
          if (routeTo) self.router.navigate([routeTo]);
        });

      this.listenForExternalClicks();
    }
  }

  listenForExternalClicks() {
    let $doc = $(document).on('click.sidebar', (e) => {
      if (!$(e.target).parents('.aside-container').length) {
        this.removeFloatingNav();
        $doc.off('click.sidebar');
      }
    });
  }

  removeFloatingNav() {
    $('.nav-floating').remove();
  }

  isSidebarCollapsed() {
    return this.settings.getLayoutSetting('isCollapsed');
  }

  isSidebarCollapsedText() {
    return this.settings.getLayoutSetting('isCollapsedText');
  }

  isEnabledHover() {
    return this.settings.getLayoutSetting('asideHover');
  }

  toggleChat() {
    this.chatService.toggleChat();
  }

  sendMessage() {
    if (this.newMessage.trim() === '') {
      return;
    }

    this.addUserMessage(this.newMessage);
    const userMessage = this.newMessage;
    this.newMessage = '';
    this.isTyping = true;

    this.repo.postRequest('/api/chatai/ask', {
      text: userMessage,
      username: this.currentUser.user_name,
      DonViId: this.currentUser.id_don_vi
    }).subscribe(
      (response: any) => {
        this.isTyping = false;
        console.log(response);

        if (response && response.UrlForm) {
          this.router.navigate([response.UrlForm]);
        }

        if (response && response.Answer) {
          this.addBotMessage(response.Answer);
        } else {
          this.addBotMessage("I'm not sure how to respond to that.");
        }
      },
      (error) => {
        this.isTyping = false;
        this.addBotMessage('Sorry, I encountered an error processing your request.');
        console.error('Error calling ChatAI API:', error);
      }
    );
  }

  addUserMessage(text: string, timestamp: Date = new Date()) {
    this.shouldScrollToBottom = true;
    this.messages.push({
      text: text,
      isUser: true,
      timestamp: timestamp
    });
  }

  addBotMessage(text: string, timestamp: Date = new Date()) {
    this.shouldScrollToBottom = true;
    this.messages.push({
      text: text,
      isUser: false,
      timestamp: timestamp
    });
  }

  onScroll(): void {
    const element = this.chatContainer.nativeElement;
    const atBottom = element.scrollHeight - element.scrollTop - element.clientHeight < 30;
    this.shouldScrollToBottom = atBottom;
  }

  generateBotResponse(userMessage: string) {
    let botResponse = 'I received your message. How can I assist you further?';

    if (userMessage.toLowerCase().includes('hello') || userMessage.toLowerCase().includes('hi')) {
      botResponse = 'Hello there! How can I help you today?';
    } else if (userMessage.toLowerCase().includes('help')) {
      botResponse = 'I can help you with information about courses, registrations, or schedule. What would you like to know?';
    } else if (userMessage.toLowerCase().includes('course') || userMessage.toLowerCase().includes('class')) {
      botResponse = 'We offer various courses. You can check course details in the Course section of the application.';
    } else if (userMessage.toLowerCase().includes('thank')) {
      botResponse = 'You\'re welcome! Feel free to ask if you need any more help.';
    }

    this.addBotMessage(botResponse);
  }
}

interface ChatResponse {
  text: string;
}

